import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import Button from "@mui/material/Button";
import store from "../../store";
import {
  notificationListValue,
  notificationNumValue,
} from "../../store/slices/notification";
import "../../assets/css/notification-page.css";
import useHttp from "../../hooks/useHttp";
import {
  NOTIFICATION_GET_URL,
  MARK_NOTIFICATION_AS_READ_URL,
  MARK_SINGLE_NOTIFICATION_AS_READ_URL,
} from "../../utils/api-ends";
import LoaderImg from "../../assets/media/loader.gif";

const Notification = () => {
  const [allValue, setAllValue] = useState([]);
  const [isSeeMoreAviable, setIsSeeMoreAviable] = useState(false);
  const [nextPageNumber, setNextPageNumber] = useState("");
  const [isRead, setIsRead] = useState(false);
  const notificationData = useSelector((state) => state.notification);
  const { isLoading, sendRequests } = useHttp();
  const { isLoading: isSeeMoreLoading, sendRequests: seeMoreRequests } =
    useHttp();
  const { isLoading: isMarkAllRead, sendRequests: markAllReadRequest } =
    useHttp();
  const { sendRequests: markSingleReadRequest } = useHttp();

  useEffect(() => {
    const response = (data) => {
      data.pagination.next_page_number > 1
        ? setIsSeeMoreAviable(true)
        : setIsSeeMoreAviable(false);
      data.pagination.next_page_number > 1
        ? setNextPageNumber(data.pagination.next_page_number)
        : setNextPageNumber("");
      setAllValue(...allValue, data.results);
    };
    // Send request to get Notification list
    sendRequests(
      {
        url: NOTIFICATION_GET_URL(1),
        method: "GET",
      },
      response
    );
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const seeMoreNotification = () => {
    const response = (data) => {
      data.pagination.next_page_number > 1
        ? setIsSeeMoreAviable(true)
        : setIsSeeMoreAviable(false);
      data.pagination.next_page_number > 1
        ? setNextPageNumber(data.pagination.next_page_number)
        : setNextPageNumber("");
      setAllValue([...allValue, ...data.results]);
    };
    // Send request to get Notification list
    seeMoreRequests(
      {
        url: NOTIFICATION_GET_URL(nextPageNumber),
        method: "GET",
      },
      response
    );
  };

  const markAllNotificationRead = () => {
    const response = (data) => {
      setIsRead(true);
      //Update the reducer value of the notification number
      store.dispatch(
        notificationNumValue({
          notificationNum: 0,
        })
      );
    };
    // Send request to make all Notification as read
    markAllReadRequest(
      {
        url: MARK_NOTIFICATION_AS_READ_URL,
        method: "PATCH",
      },
      response
    );
  };

  const markSingleNotificationRead = (e) => {
    const notificationId = e.target
      .closest(".notification-boxes")
      .getAttribute("notificationId");
    const response = (data) => {
      //Update the reducer value of the notification number
      if (notificationData.notificationNum > 0) {
        store.dispatch(
          notificationNumValue({
            notificationNum: notificationData.notificationNum - 1,
          })
        );
      }
      allValue?.map((value, index) =>
        value.id === notificationId
          ? store.dispatch(
              notificationListValue({
                /* notificationValue: [...notificationData.notificationList, ...notificationData.notificationList[index]['is_read']=true], */
                notificationValue: notificationData.notificationList,
              })
            )
          : ""
      );
      allValue?.map((value, index) =>
        value.id === notificationId
          ? setAllValue([...allValue, ...(allValue[index]["is_read"] = true)])
          : ""
      );
    };
    // Send request to make a single Notification as read
    markSingleReadRequest(
      {
        url: MARK_SINGLE_NOTIFICATION_AS_READ_URL(notificationId),
        method: "PATCH",
      },
      response
    );
  };

  return (
    <>
      <section>
        <div className="notification-container">
          <h1 className="large-text text-center"> Notification </h1>
          <div className="notification-read-all">
            <Button onClick={markAllNotificationRead} variant="outlined">
              Mark All As Read
              {isMarkAllRead && (
                <img
                  style={{ width: "20px", marginLeft: "5px" }}
                  src={LoaderImg}
                  alt=""
                />
              )}
            </Button>
          </div>

          {isLoading ? (
            <div className="loader d-flex justify-content-center mb-5 mt-5">
              <img style={{ width: "35px" }} src={LoaderImg} alt="" />
            </div>
          ) : (
            <>
              {allValue?.length > 0 ? (
                allValue?.map((value, index) => (
                  <div
                    className="notification-boxes"
                    notification={isRead || value.is_read ? "read" : "unread"}
                    notificationId={value.id}
                    onClick={markSingleNotificationRead}
                  >
                    <div className="notification-text">
                      <Link
                        to={
                          value.notification_link
                            ? value.notification_link
                            : "/notification"
                        }
                      >
                        <p>{value.message}</p>
                      </Link>
                      <span>{value.notification_created_datetime}</span>
                    </div>
                    {isRead || value.is_read ? (
                      <div>
                        <i className="fa-solid fa-envelope-open"></i>
                      </div>
                    ) : (
                      ""
                    )}
                    {isRead || value.is_read ? (
                      ""
                    ) : (
                      <div>
                        <i className="fa-solid fa-envelope"></i>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div className="no-notification-data-style">
                  <p>No notification data available</p>
                </div>
              )}
            </>
          )}

          {isSeeMoreAviable ? (
            <div className="multiple-btn mt-5">
              <button onClick={seeMoreNotification}>
                See More
                {isSeeMoreLoading && (
                  <img
                    style={{ width: "26px", marginLeft: "5px" }}
                    src={LoaderImg}
                    alt=""
                  />
                )}
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
      </section>
    </>
  );
};

export default Notification;
